import type { IPropertyImageInfo } from "@/services/campayacore-api.service";

// export const generateSrcSet = (image: IPropertyImageInfo) => {
//   return `${image} 640w, ` +
//          `${image} 768w, ` +
//          `${image} 1024w, ` +
//          `${image} 1280w, ` +
//          `${image} 1536w, ` +
//          `${image} 1680w, ` +
//          `${image} 1920w`;
// }
const crops = {
  "xs": 640,
  "sm": 768,
  "lg": 1024,
  "xl": 1280,
  "xxl": 1536,
  "xxxl": 1920
}

// using the cds with cropping and fill
export const generateSrcSet = (options: { image: IPropertyImageInfo, fileExtension: string, maxCrop: number, cropDimensions: number }) => {
  const minXs = Math.min(options.maxCrop, crops.xs);
  const minSm = Math.min(options.maxCrop, crops.sm);
  const minLg = Math.min(options.maxCrop, crops.lg);
  const minXl = Math.min(options.maxCrop, crops.xl);
  const minXxl = Math.min(options.maxCrop, crops.xxl);
  const minXxxl = Math.min(options.maxCrop, crops.xxxl);
  
  let localFileExtension = options.fileExtension ? `.${options.fileExtension}` : `${options.fileExtension}`
  
  let webpSources = 
    `${options.image}_Crop_${minXs}_${Math.round(minXs * options.cropDimensions)}.webp 640w, ` +
    `${options.image}_Crop_${minSm}_${Math.round(minSm * options.cropDimensions)}.webp 768w, ` +
    `${options.image}_Crop_${minLg}_${Math.round(minLg * options.cropDimensions)}.webp 1024w, ` +
    `${options.image}_Crop_${minXl}_${Math.round(minXl * options.cropDimensions)}.webp 1280w, ` +
    `${options.image}_Crop_${minXxl}_${Math.round(minXxl * options.cropDimensions)}.webp 1536w, ` +
    `${options.image}_Crop_${minXxxl}_${Math.round(minXxxl * options.cropDimensions)}.webp 1920w, `;
  
  return (
    webpSources +
    `${options.image}_Crop_${minXs}_${Math.round(minXs * options.cropDimensions)}${localFileExtension} 640w, ` +
    `${options.image}_Crop_${minSm}_${Math.round(minSm * options.cropDimensions)}${localFileExtension} 768w, ` +
    `${options.image}_Crop_${minLg}_${Math.round(minLg * options.cropDimensions)}${localFileExtension} 1024w, ` +
    `${options.image}_Crop_${minXl}_${Math.round(minXl * options.cropDimensions)}${localFileExtension} 1280w, ` +
    `${options.image}_Crop_${minXxl}_${Math.round(minXxl * options.cropDimensions)}${localFileExtension} 1536w, ` +
    `${options.image}_Crop_${minXxxl}_${Math.round(minXxxl * options.cropDimensions)}${localFileExtension} 1920w, `)
}